import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {formatVideoLength} from '../../../utils/formatting';

import * as videosActionCreators from '../../../actions/videos';
let allActionCreators = Object.assign({}, videosActionCreators);


class VideoTile extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {};
	}

	getVideoSrc(videoId) {
		return 'img/covers/' + videoId + '.png';
	}

	videoNav() {
		this.props.videosSetCurrent(this.props.video);
		this.context.router.push('/watch');
	}

	render() {
		return (
			<div 
				className='VideoTile'
				onClick={::this.videoNav}>
				<div className='videoCover'>
					<img src={this.getVideoSrc(this.props.video.videoId)} />
				</div>
				<div className='videoLabel'>
					<div className='videoTitle'>{this.props.video.name}</div>
					<div className='videoLength'>{formatVideoLength(this.props.video.videoLength)}</div>
				</div>
			</div>
		);
	}
}
export default VideoTile;

function mapStateToProps(state) {
  return {
    common: state.common,
    videos: state.videos,
  };
}

export const VideoTileContainer = connect(
  mapStateToProps,
  allActionCreators
)(VideoTile);


// WEBPACK FOOTER //
// ./src/components/views/videos/VideoTile.jsx